<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card
        class="mx-auto"
      >
        <v-card-title class="title font-weight-regular justify-space-between">
          <v-avatar
              color="primary lighten-2"
              class="subheading white--text"
              size="24"
              v-text="step"
            ></v-avatar>
          <span>ענה על 4 שאלות האשף להתאמת חבילה</span>
          <!-- <span>Package wizard</span> -->
          <span>
            <v-btn class="ma-0" depressed flat fab small @click="closeModal()">
              <v-icon>close</v-icon>
            </v-btn>
          </span>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-layout v-if="loading" row justify-center py-5 >
            <v-progress-circular
              :size="150"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </v-layout>
          <v-layout v-else row wrap pb-3>
            <v-window v-model="step" v-if="wizard">
              <v-window-item :value="0">
                <v-card-text>
                  <template v-if="$store.state.user.package_id && $store.state.user.package_type ===  $store.state.plan.packageType.BIGGER">
                    <h3 class="title font-weight-light">החבילה שלך כוללת:</h3>
                    <!-- <h3 class="title font-weight-light">Your "Bigger" package includes:</h3> -->
                    <ul class="package-attr-list my-2 ml-2">
                      <li v-for="step in wizard.steps" :key="'includes_' + step.attribute">
                        <template v-if="[$store.state.plan.attributesType.LIST, $store.state.plan.attributesType.RANGE].includes($store.state.plan.attributes[step.attribute].type)">
                          <!-- TODO: show correct values -->
                          {{ getAttributeName(step.attribute) }}:&nbsp;<b>{{ $store.state.user.permissions[step.attribute] }}</b>
                        </template>
                        <template v-else-if="$store.state.plan.attributes[step.attribute].type === $store.state.plan.attributesType.BOOL">
                          {{ getAttributeName(step.attribute) }}:&nbsp;<b>{{ $store.state.user.permissions[step.attribute] ? 'Yes' : 'No' }}</b>
                        </template>
                        <template v-else>
                          {{ getAttributeName(step.attribute) }}:&nbsp;<b>{{ $store.state.user.permissions[step.attribute] }}</b>
                        </template>
                      </li>
                      <li>חיפושים יומיים במנוע החיפוש של 'ביגר': <b>100</b> </li>
                      <li>תאריך חידוש החבילה יתבצע ב: <b>{{ $moment($store.state.user.package_expired_at).format('DD-MM-YYYY') }}</b> </li>
                    </ul>
                  </template>
                  <template v-else>
                    <v-alert
                      class="mb-4"
                      :value="true"
                      color="warning"
                      icon="priority_high"
                      outline
                    >
                      <span class="subheading">להתחלה לחץ על כפתור 'הבא'</span>
                    </v-alert>
                    <h3 class="title font-weight-light">הצעדים הבאים כוללים:</h3>
                    <ul class="package-attr-list my-2 ml-2">
                      <li>בחירת כמות פרוייקטים רצויה </li>
                      <li>בחירת כמות מילים לחשבון</li>
                      <li> בחירת כמות וסוג הדוחות (מיקומים בלבד או מיקומים + נתוני אנליטיקס)</li>
                    </ul>
                  </template>
                </v-card-text>
              </v-window-item>

              <template v-for="step in wizard.steps">
                <v-window-item :value="step.order" :key="'step_' + step.attribute">
                  <v-card-text>
                    <h3 class="title font-weight-light">{{ step.description }}</h3>
                    <v-radio-group v-model="form[step.attribute]" class="pl-3 pt-2 wizard-radio-group">
                      <template v-for="option in step.options">
                        <v-radio
                          :key="'step_' + step.attribute + '_option' + option.description"
                          class="mb-3"
                          :label="option.description"
                          :value="option.value"
                        ></v-radio>
                      </template>
                    </v-radio-group>
                  </v-card-text>
                </v-window-item>
              </template>

              <v-window-item :value="wizard.steps.length + 1">
                <div class="pa-3 text-xs-center">
                  <h3 class="title font-weight-light my-5 pb-4">
                    "Bigger" package total price:
                    <span class="font-weight-bold">
                      <span v-if="packageDiscountPrice !== packageCleanPrice" style="text-decoration: line-through;">
                        {{ packageCleanPrice }}{{ $store.state.metadata.currencySign[selectedCurrency] }}
                      </span>
                      <span>{{ Number((packageDiscountPrice).toFixed(2)) }}{{ $store.state.metadata.currencySign[selectedCurrency] }}</span>
                    </span> per month
                  </h3>
                </div>
              </v-window-item>
            </v-window>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <template v-if="wizard">
            <v-btn
              :disabled="step === 0"
              flat
              @click="previousStep()"
            >
              חזרה לצעד קודם
              <!-- Back -->
            </v-btn>
            <v-btn
              v-if="step === (wizard.steps.length + 1)"
              class="orange--text"
              @click="applyCouponDialog = true"
              :loading="loading"
              :disabled="loading"
            >
              Apply Promo Code
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="step !== (wizard.steps.length + 1)"
              :disabled="!wizard"
              color="primary"
              depressed
              @click="$forceUpdate(); nextStep()"
            >
              הבא
              <!-- Next -->
            </v-btn>
            <v-btn
              v-else
              color="warning"
              depressed
              @click="sendPayment()"
              :loading="loading"
              :disabled="loading"
            >
              Buy Package
            </v-btn>
          </template>
          <template v-else>
            <div>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
            </div>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmModal v-if="confirmDialog" :confirmDialog="confirmDialog" :confirmText="confirmText" type="warning" :loading="loading"></ConfirmModal>
    <ApplyCouponModal v-if="applyCouponDialog" :applyCouponDialog="applyCouponDialog"></ApplyCouponModal>
  </v-layout>
</template>

<script>
import ConfirmMixin from '@/mixins/ConfirmMixin'
export default {
  name: 'WizardModal',
  mixins: [ConfirmMixin],
  $_veeValidate: {
    validator: 'new'
  },
  props: ['wizardDialog'],
  data () {
    return {
      isAdmin: this.$store.state.user.permissions.is_admin,
      loading: false,
      attributesNames: {
        'projects_count': 'פרוייקטים',
        'keywords_count': 'מילות מפתח',
        'global_reports_count': 'דוחות מיקומים',
        // 'global_level_type': 'חיבור לגוגל אנליטיקס וסרץ קונסול לדוחות מורחבים',
        'google_account_projects_only': 'חיבור לגוגל אנליטיקס וסרץ קונסול לדוחות מורחבים'
      },
      dialog: this.wizardDialog,
      discountCoefficient: 1,
      packageCleanPrice: 0,
      packageDiscountPrice: 0,
      applyCouponDialog: false,
      step: 0,
      wizard: null,
      selectedCurrency: this.$store.state.metadata.currencies[this.$store.state.user.currency],
      form: {}
    }
  },
  created () {
    // this.getCategories()
    // this.getSubcategories()
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    this.$eventEmitter
      .$on('applyCouponDialog', (value) => {
        this.applyCouponDialog = value
      })
      .$on('updateWizardPrice', () => {
        this.getWizardDiscount()
      })
    this.getWizard()
  },
  computed: {
    totalPrice () {
      this.step; // eslint-disable-line
      let total = 0
      total += this.wizard.clean_price
      // total += this.wizard.default_price
      this.wizard.steps.forEach(step => {
        step.options.forEach(option => {
          if (option.value === this.form[step.attribute]) {
            total = (total * 100 + option.clean_price * 100) / 100
          }
        })
      })
      return total
    }
  },
  watch: {
    wizardDialog: {
      handler () {
        this.dialog = this.wizardDialog
      }
    },
    dialog: {
      handler () {
        this.$eventEmitter.$emit('wizardDialog', this.dialog)
      }
    }
  },
  beforeDestroy () {
    this.$eventEmitter.$off('applyCouponDialog')
    this.$eventEmitter.$off('updateWizardPrice')
  },
  methods: {
    getAttributeName (attr) {
      if (this.attributesNames[attr]) {
        return this.attributesNames[attr]
      } else {
        return this.$store.state.plan.attributes[attr].description
      }
    },
    nextStep () {
      // if (this.step === 2) {
      //   this.form.global_reports_count = 0
      //   this.form.global_level_type = 0
      //   this.step += 3
      // } else {
      //   this.step++
      // }
      if (this.step === 3) {
        if (this.form.global_reports_count === 0) {
          // this.form.global_level_type = 0
          this.form.google_account_projects_only = false
          this.step += 2
        } else {
          // this.form.global_level_type = 1
          this.form.google_account_projects_only = true
          this.step++
        }
      } else {
        this.step++
      }
      if (this.wizard.steps.length + 1 === this.step) {
        this.getWizardDiscount()
      }
    },
    previousStep () {
      // if (this.step === 5) {
      //   this.step -= 3
      // } else {
      //   this.step--
      // }
      if (this.step === 5 && this.form.global_reports_count === 0) {
        this.step -= 2
      } else {
        this.step--
      }
    },
    getWizard () {
      this.loading = true
      this.$store.dispatch('GET_WIZARD', this.$store.state.plan.wizardType.BIGGER).then(res => {
        if (res.wizard) {
          this.wizard = res.wizard
          this.wizard.steps.forEach(step => {
            if (this.$store.state.user.package_id && this.$store.state.user.package_type === this.$store.state.plan.packageType.BIGGER) {
              this.form[step.attribute] = this.$store.state.user.permissions[step.attribute]
            } else {
              this.form[step.attribute] = step.options[0].value
            }
          })
          this.getWizardDiscount()
        }
        this.loading = false
      }, err => {
        this.loading = false
        console.log('GET_WIZARD error', err)
        this.$toasted.show('GET_WIZARD Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    getWizardDiscount () {
      this.loading = true
      this.$store.dispatch('GET_WIZARD_DISCOUNT', { wizardId: this.wizard.id, stepsValues: this.form }).then(res => {
        this.discountCoefficient = res.discount_coefficient
        this.packageCleanPrice = res.clean_price
        this.packageDiscountPrice = res.discount_price

        this.loading = false
      }, err => {
        this.loading = false
        console.log('GET_WIZARD_DISCOUNT error', err)
        this.$toasted.show('GET_WIZARD_DISCOUNT Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    sendPayment () {
      this.loading = true
      this.$store.dispatch('BUY_THROUGH_WIZARD', { wizardId: this.wizard.id, stepsValues: this.form }).then(res => {
        if (res && res.redirect_url) {
          window.location.href = res.redirect_url
        } else {
          this.$toasted.show('Package setting were successfully changed')
          this.updateUserData()
          this.closeModal()
        }
        this.loading = false
      }, err => {
        this.loading = false
        console.log('BUY_THROUGH_WIZARD error', err)
        this.$toasted.show('BUY_THROUGH_WIZARD Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    updateUserData () {
      this.loading = true
      this.$store.dispatch('GET_USER_DATA').then(res => {
        this.$store.dispatch('GET_PERMISSIONS').then(res => {
          this.$store.dispatch('GET_METADATA')
        }, err => {
          this.loading = false
          console.log('GET_PERMISSIONS error', err)
          this.$toasted.show('GET_PERMISSIONS Error: ' + this.$services.getApiError(err), { type: 'error' })
        })
        this.$store.commit('TOGGLE_NAVIGATION_MENU', true)
      }, err => {
        this.loading = false
        console.log('GET_USER_DATA error', err)
        this.$toasted.show('GET_USER_DATA Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    calculateRefund () {
      let params = {
        products: this.preparePaymentsParams(),
        currency: this.$store.state.subscription.currency[this.selectedCurrency]
      }
      this.loading = true
      this.$store.dispatch('CALCULATE_REFUND', params).then(res => {
        if (res && (res.extras_will_be_cancelled || res.refund_amount || this.$store.state.user.credits !== 0)) {
          let confirmText = ''
          if (res.refund_amount) confirmText += `If you continue then you will get refund to system wallet <b>${Number(res.refund_amount.toFixed(2))}&nbsp;${this.$store.state.metadata.currencySign[this.selectedCurrency]}</b>. `
          // if (this.$store.state.user.credits !== 0) confirmText += `If you continue then you will get refund to system wallet <b>${Number(res.refund_amount.toFixed(2))} ${this.$store.state.metadata.currencySign[this.selectedCurrency]}</b>. `
          if (res.extras_will_be_cancelled) confirmText += 'And all your extra products will be cancelled.'
          confirmText += '<p>If you have some questions you can contact customers service.<p/>'
          this.callConfirm(
            'sendPayment',
            confirmText,
            null
          )
          this.loading = false
        } else {
          this.sendPayment()
        }
      }, err => {
        this.loading = false
        console.log('CALCULATE_REFUND error', err)
        this.$toasted.show('CALCULATE_REFUND Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    closeModal () {
      this.dialog = false
      this.discountCoefficient = 1
      this.clearForm()
      // this.$router.push({name: 'SearchTool'})
    },
    clearForm () {
      this.form = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.package-attr-list {
  color: rgba(0,0,0,.64);
  font-size: 16px;
  li {
    line-height: 3;
  }
}
.wizard-radio-group {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/subscriptions/WizardModal.vue